import { BaseApiService } from './baseApi';
//  correction - Import depuis le système unifié
import type { User, LoginCredentials, ApiResponse } from '../../../../types';

export interface AuthResponse {
  user: User;
  token: string;
  expiresIn?: number;
}

export class AuthApiService extends BaseApiService {
  constructor() {
    super('/auth');
  }

  /**
   * Login utilisateur
   */
  async login(credentials: LoginCredentials): Promise<ApiResponse<AuthResponse>> {
    const response = await this.requestPost<AuthResponse>('/login', credentials, false);

    if (response.success && response.data?.token) {
      // Sauvegarder le token
      localStorage.setItem('auth_token', response.data.token);
      localStorage.setItem('portfolio_user', JSON.stringify(response.data.user));
    }

    return response;
  }

  /**
   * Logout utilisateur
   */
  async logout(): Promise<ApiResponse<boolean>> {
  try {
    //  correction - Utiliser la response ou supprimer la variable
    await this.requestPost<boolean>('/logout');
  } catch (error) {
    console.log('Logout error:', error);
  } finally {
    // Nettoyer le storage local dans tous les case
    localStorage.removeItem('auth_token');
    localStorage.removeItem('portfolio_user');
  }

  return {
    success: true,
    data: true,
    message: 'Déconnexion réussie'
  };
}

  /**
   * Validate la validité du token
   */
  async verifyToken(): Promise<ApiResponse<{ valid: boolean; user?: User }>> {
    return this.requestGet<{ valid: boolean; user?: User }>('/verify');
  }

  /**
   *  Get l'utilisateur actuel avec gestion du null
   */
  async getCurrentUser(): Promise<User | null> {
    try {
      const response = await this.requestGet<{ user: User }>('/me');

      if (response.success && response.data?.user) {
        //  case normal : API retourne l'user
        return response.data.user;
      } else {
        //  Fallback vers localStorage
        const userStr = localStorage.getItem('portfolio_user');
        if (userStr) {
          try {
            const userData = JSON.parse(userStr);
            return userData;
          } catch (parseError) {
            return null;
          }
        } else {
          return null;
        }
      }
    } catch (error: any) {
      //  Fallback vers localStorage en case d'error network
      try {
        const userStr = localStorage.getItem('portfolio_user');
        if (userStr) {
          const userData = JSON.parse(userStr);
          return userData;
        }
      } catch (parseError) {
        }

      return null; // ✅ return null explicite
    }
  }

  /**
   * Signup (si implémentée côté backend)
   */
  async register(userData: {
    email: string;
    password: string;
    name: string;
  }): Promise<ApiResponse<AuthResponse>> {
    return this.requestPost<AuthResponse>('/register', userData, false);
  }
}

export const authApi = new AuthApiService();
